import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../utils/LoadingSpinner';

const formatDateLabel = (id) => {
	if (!id) return '';
	const { year, month, day, hour, minute } = id;
	let label = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
	if (hour !== undefined) label += ` ${String(hour).padStart(2, '0')}:00`;
	if (minute !== undefined) label = label.replace(':00', `:${String(minute).padStart(2, '0')}`);
	return label;
}

const StatsThroughputChart = ({ data, loading }) => {
	if (loading) {
		return <LoadingSpinner loadingMsg='Loading throughput data' />;
	}

	if (!data || data.length === 0) {
		return <p className='text-center text-muted mt-3'>No throughput data available</p>;
	}

	const chartData = data.map(item => ({
		label: formatDateLabel(item._id),
		count: item.count || 0,
		avg_process_ms: item.avg_process ? Math.round(item.avg_process * 1000) : 0
	}));

	return (
		<ResponsiveContainer width='100%' height={350}>
			<ComposedChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
				<CartesianGrid strokeDasharray='3 3' />
				<XAxis dataKey='label' fontSize={12} />
				<YAxis yAxisId='left' />
				<YAxis yAxisId='right' orientation='right' />
				<Tooltip />
				<Legend />
				<Bar yAxisId='left' dataKey='count' fill='#0d6efd' name='Requests' />
				<Line yAxisId='right' type='monotone' dataKey='avg_process_ms' stroke='#fd7e14' name='Avg Process (ms)' dot={false} />
			</ComposedChart>
		</ResponsiveContainer>
	);
}

StatsThroughputChart.propTypes = {
	data: PropTypes.array,
	loading: PropTypes.bool
}

export default StatsThroughputChart;
